import BeneficioModel from "../models/beneficio/beneficioModel";
import nfetch from "../utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class BeneficioService extends iServiceCached<BeneficioModel> {
    constructor() {
        super("Beneficio");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.descricao,
            franquiaId: p.franquiaId,
        }));
    }

    public getFromUsuarioLogado(): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFromUsuarioLogado?`, {
            credentials: "same-origin",
        });
    }

    public getFromCliente(clienteId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFromCliente?clienteId=${clienteId}`, {
            credentials: "same-origin",
        });
    }
}

export default new BeneficioService();
